module.exports = __webpack_public_path__ + "static/media/Niveau_elN10_1_316186.4fa636e2.png";